import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import InstagramIcon from '../images/instagram.png';
import LinkedInIcon from '../images/linkedin.png';

const Footer = () => {
    return (
        <>  
            <footer>
                <div className="footer max-w-full mx-auto px-4 sm:px-6 bg-gray-100 border-t border-b py-30">
                    <div className="grid sm:grid-cols-12 gap-5 py-8 md:py-12 border-t border-gray-200 lg:ml-11">
                        <div className="col-span-12 lg:col-span-4">
                            <div className="box-border border-b-4 border-blue-900 p-8 bg-gray-200 text-gray-600 text-center rounded-lg xl:w-80 mx-auto">
                                <h3 className="font-bold text-4xl mb-4">DuoRoot Software</h3>
                                <div className='text-md font-medium text-gray-600'>
                                    <h5>DuoRoot</h5>
                                    <p>Ankara, Türkiye</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-span-12 text-center mx-auto lg:col-span-3 font-bold uppercase text-white">
                            <div className="text-xl mb-6">Social Media Links.</div>
                            <div className="text-md font-medium mb-6">Follow us on social media.</div>
                            <div className="mx-auto text-center mt-2">
                                <ul className="flex justify-center mb-4 md:mb-0">
                                    <li>
                                        <a
                                            href="https://www.instagram.com/duorootsoftware/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="flex justify-center items-center text-blue-900 hover:text-gray-500 bg-white rounded-full shadow transition duration-150 ease-in-out"
                                            aria-label="Instagram"
                                        >
                                            <img src={InstagramIcon} alt="Instagram" className="w-8 h-8" />
                                        </a>
                                    </li>
                                    <li className="ml-4">
                                        <a
                                            href="https://www.linkedin.com/duoroot-software?_l=en_US"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="flex justify-center items-center text-blue-900 hover:text-gray-500 bg-white rounded-full shadow transition duration-150 ease-in-out"
                                            aria-label="LinkedIn"
                                        >
                                            <img src={LinkedInIcon} alt="LinkedIn" className="w-8 h-8" />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-wrap items-center md:justify-between justify-center mx-auto px-4">
                        <div className="w-full md:w-4/12 px-4 mx-auto text-center py-2">
                            <div className="text-sm text-white font-semibold py-1">
                                Copyright &copy; {new Date().getFullYear()}{" "}
                                <HashLink to="#" className="hover:text-gray-900">
                                    DuoRoot Software
                                </HashLink>. All rights reserved.
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Footer;
